export default __webpack_public_path__ + "static/media/button_deposit.997d88f3.svg";